import { memo, useMemo } from "react";
import SelectComponent from "ui-kit/src/SelectComponent/SelectComponent";
import Icon from "../../../../../admin/src/components/Icon";
import { Button } from "../../../../../ui-kit-v2/src/button/button";
import { _ } from "i18n";
import { StatsLinedTabsAdapter } from "./StatsLinedTabsAdapter";
import { isDefaultCategory } from "./functions";
import { CustomTab, InsightEventGroupEnum, CUSTOM_GROUP_KEY, MAX_CATEGORY_TABS } from "./constants";
import { SelectValue } from "ui-kit/src/MultipleSelect/types";
import { useInsightTabStore } from "./insight-tab-store";

interface CategoryTabsProps {
	categoryTabs: CustomTab[];
	customTabs: CustomTab[];
	userCustomTabs: CustomTab[];
	selectedDropdownCategory: SelectValue | undefined;
	onDropdownCategoryChange: (selected: SelectValue) => void;
	onEditTab: () => void;
	onAddTab: () => void;
}

const CategoryTabs = memo(
	({
		categoryTabs,
		customTabs,
		userCustomTabs,
		selectedDropdownCategory,
		onDropdownCategoryChange,
		onEditTab,
		onAddTab,
	}: CategoryTabsProps) => {
		// Get tab state directly from Zustand store - completely independent from content
		const activeCategoryTab = useInsightTabStore((state) => state.activeCategoryTab);
		const setActiveCategoryTab = useInsightTabStore((state) => state.setActiveCategoryTab);

		const handleCategoryTabChange = (key: InsightEventGroupEnum) => {
			// Direct store update - immediate and non-blocking
			setActiveCategoryTab(key);
		};
		return (
			<div className="insight-page-container__categories">
				<div className="insight-page-container__categories-tabs">
					<div className="insight-page-container__categories-tabs-lined-tabs">
						<StatsLinedTabsAdapter tabs={categoryTabs} active={activeCategoryTab} onChange={handleCategoryTabChange} />
						<div className="insight-page-container__categories-tabs-custom-widgets"></div>
					</div>

					<div
						className={`insight-page-container__categories-dropdown ${
							customTabs.length > 0 || userCustomTabs.length > 0 ? "" : "display-none"
						}`}
					>
						<SelectComponent
							value={selectedDropdownCategory}
							items={[
								...(categoryTabs
									?.filter((tab) => !isDefaultCategory(tab.key as InsightEventGroupEnum))
									.map((tab) => ({
										value: tab.key,
										label: tab.label,
									})) ?? []),
							]}
							isCleareable={false}
							placeholder={`${_("gamePage.dataInsights.label.customInsights")}`}
							handleChange={(selected: SelectValue) => {
								if (selected?.value !== undefined) {
									// Update store immediately
									setActiveCategoryTab(selected.value as InsightEventGroupEnum);
									// Also call the parent handler for other side effects (like setting dropdown state)
									onDropdownCategoryChange(selected);
								}
							}}
							referenced={true}
						/>
						{activeCategoryTab?.includes(CUSTOM_GROUP_KEY) && (
							<>
								<Button className="btn btn--grey" onClick={onEditTab}>
									<Icon icon="pencil" size={24} color="dark-grey" />
								</Button>
							</>
						)}
					</div>
					{categoryTabs.length <= MAX_CATEGORY_TABS && (
						<div className="insight-page-container__categories-tabs-add-tab lined-tabs">
							<div className="lined-tabs__item add-tab-button" onClick={onAddTab}>
								<Icon icon="zoom-more" size={12} color="dark-grey" />
								&nbsp;{_("gamePage.dataInsights.label.addTab")}
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
);

export default CategoryTabs;
